import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { compose } from 'recompose';

import AuthUserContext from './context';
import * as ROUTES from '../constants/routes';
import { onAuthUserListener } from '../firebase/api/auth';
import WithRouter from '../helpers/WithRouter';

const withAuthorization = condition => Component => {
    class WithAuthorization extends React.Component {
        componentDidMount() {
            this.listener = onAuthUserListener(
                authUser => {
                    if (
                        !this.props.location.pathname.includes('/preview/') &&
                        !this.props.location.pathname.includes('/policy') &&
                        !condition(authUser)
                    ) {
                        this.props.navigate(ROUTES.LANDING);
                    }
                },
                () => {
                    console.log('fallback');
                    if (
                        !this.props.location.pathname.includes('/preview/') &&
                        !this.props.location.pathname.includes(ROUTES.SIGN_IN) &&
                        !this.props.location.pathname.includes(ROUTES.SIGN_UP) &&
                        !this.props.location.pathname.includes(ROUTES.RESET_PASSWORD)
                    ) {
                        this.props.navigate(ROUTES.LANDING);
                    }
                }
            );
        }

        componentWillUnmount() {
            this.listener();
        }

        render() {
            return (
                <AuthUserContext.Consumer>
                    {authUser => (condition(authUser) ? <Component {...this.props} /> : null)}
                </AuthUserContext.Consumer>
            );
        }
    }

    return compose(WithRouter)(WithAuthorization);
};

export default withAuthorization;
